import React, { useState, useEffect } from "react";
import {createGlobalStyle} from "styled-components"
import Calendar from 'rc-year-calendar';
import 'rc-year-calendar/locales/rc-year-calendar.es';
import { getVacationsHistory, getVacationsSummary } from "../../services/VacationHistoryService";
import { getBankHolidays } from "../../services/BankHolidaysService";
import 'bootstrap/dist/css/bootstrap.min.css';
import { VacationsContext } from "../../context/VacationsContext";
import EmployeeVacationsList from "./EmployeeVacationsList";

const CalendarStyle = createGlobalStyle`
  .calendar {
    overflow-x: visible !important;
  }
  .calendar .months-container .month-container {
    margin-bottom: 1%;
  }
`

const EmployeeVacations = ({ userId }) => {

    const [updateCalendar, setUpdateCalendar] = useState('');

    const updateCalendarParent = (update) => {
        setUpdateCalendar(update);
    };

    const contextValue = {
        updateParent: updateCalendar,
        setUpdateParent: updateCalendarParent
    };

    const [year, setYear] = useState(new Date().getFullYear());
    const currentYear = new Date().getFullYear();
    const [dataSource, setDataSource] = useState([]);
    let [pendingDays, setPendingDays] = useState();
    let [approvedDays, setApprovedDays] = useState();
    let [availableDays, setAvailableDays] = useState();

    const getSummary = async () => {
        const data = await getVacationsSummary(userId, year);
        setPendingDays(data.pending_days);
        setApprovedDays(data.approved_days);
        setAvailableDays(data.total_days);
    } 

    const getVacations = async (userId) => {
        let color;
        let disabled;
        let data = [];
        let res = await getVacationsHistory(userId, year, false);
        for (const key in res) {
            if (res[key].status === "APPROVED" || res[key].status === "PENDING") {
                if (res[key].status === "PENDING") {
                    color = "#ffd500";
                    disabled = true;
                } else if (res[key].status === "APPROVED") {
                    color = "#009134FF";
                    disabled = true;
                }

                data.push({
                    name: "Vacaciones",
                    startDate: new Date(res[key].start_date),
                    endDate: new Date(res[key].end_date),
                    color: color,
                    disabled: disabled
                })                
            }
        }
    
        res = await getBankHolidays(year);
        for (const key in res) {
            data.push({
                name: res[key].name,
                startDate: new Date(res[key].date),
                endDate: new Date(res[key].date),
                color: "#dc3545"
            })
        }
        return data;
    }

    const yearChange = async (e) => {
        setYear(e.currentYear);
    }

    useEffect(() => {
        getVacations(userId).then((data) => {
            setDataSource(data);
        })
        getSummary();
    }, [updateCalendar, year])
    
    return (
        <div className="container">
            <div className="row align-items-center my-5">
                <div>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-9" data-testid="calendar">
                                <Calendar
                                    style="background"
                                    language="es"
                                    weekStart={1}
                                    enableContextMenu={true}
                                    enableRangeSelection={true}
                                    disabledWeekDays={[0,6]}
                                    minDate={new Date("2022-01-01")}
                                    maxDate={new Date((currentYear+1).toString()+"-12-31")}
                                    dataSource={dataSource}
                                    onYearChanged={(e) => yearChange(e)}
                                />
                            </div>
                            <div className="col-md-3" data-testid="summary">
                                <div className="list-group">
                                    <div className="list-group-item justify-content-between">
                                        Días disponibles <span className="badge badge-primary badge-pill">{availableDays}</span>
                                    </div> 
                                    <div className="list-group-item justify-content-between">
                                        Días aprobados <span className="badge badge-success badge-pill">{approvedDays}</span>
                                    </div> 
                                    <div className="list-group-item justify-content-between">
                                        Días pendientes <span className="badge badge-warning badge-pill">{pendingDays}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <CalendarStyle />
                    <div>
                        <div>
                            <h4>Histórico</h4>
                        </div>
                        <VacationsContext.Provider value={contextValue}>
                            <EmployeeVacationsList year={year} userId={userId}/>
                        </VacationsContext.Provider>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EmployeeVacations;